import { render, staticRenderFns } from "./TicketIssueDetail.vue?vue&type=template&id=3c62b058&scoped=true&"
import script from "./TicketIssueDetail.vue?vue&type=script&lang=js&"
export * from "./TicketIssueDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/ticketing.css?vue&type=style&index=0&lang=css&"
import style1 from "./TicketIssueDetail.vue?vue&type=style&index=1&id=3c62b058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62b058",
  null
  
)

export default component.exports